export class PetHistoryModel {
    msg: string
    hist: string
    tag: string
    seq_no: number
    hist_seq: number

    constructor(
        msg: string,
        hist: string,
        tag: string,
        seq_no: number,
        hist_seq: number
    ) {
        this.msg = msg
        this.hist = hist
        this.tag = tag
        this.seq_no = seq_no
        this.hist_seq = hist_seq
    }
}